import { useFormikContext } from "formik";
import {
  handleChangeHelper,
  handleOnBlurHelper,
  validateHelper,
} from "./formikInputHelper";
import { useContext } from "react";
import FormikControlContext from "../../../Contexts/FormikControlContext";

function useFormikInput() {
  const field = useContext(FormikControlContext);
  const { arrayIndex, productName } = field;

  const formik = useFormikContext();

  const handleChange = (event) => {
    formik.handleChange(event);
    // Calling helper function
    handleChangeHelper(event, productName, arrayIndex, formik);
  };

  const handleBlur = (event) => {
    // Calling helper function
    handleOnBlurHelper(event, productName, arrayIndex, formik);
  };

  const validate = (value) => {
    return validateHelper(value, field, formik);
  };

  return { handleChange, handleBlur, validate };
}

export default useFormikInput;
